import styles from "./Logo.module.css";

function Logo() {
  return (
    <svg
      className={styles.icon}
      viewBox="0 0 309 290"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M34.1991 80.5395L154.5 15.3544L274.801 80.5395V209.461L154.5 274.646L34.1991 209.461V80.5395Z"
        fill="#ECECEC"
        stroke="black"
        stroke-width="27"
      />
      <path
        d="M28.6991 77.2641L154.5 9.09893L280.301 77.2641V212.736L154.5 280.901L28.6991 212.736V77.2641Z"
        stroke="#FFFF00"
        stroke-width="16"
      />
      <path
        d="M93.8344 185.12V114.88C93.8344 106.133 96.8744 99.7333 102.954 95.68C109.141 91.6267 117.674 89.6 128.554 89.6C139.434 89.6 147.754 92.4267 153.514 98.08C159.168 92.4267 167.434 89.6 178.314 89.6C201.568 89.6 213.194 98.0267 213.194 114.88V185.12C213.194 187.573 211.061 188.8 206.794 188.8C202.528 188.8 200.394 187.573 200.394 185.12V113.28C200.394 104.96 193.621 100.8 180.074 100.8C166.634 100.8 159.914 105.067 159.914 113.6V185.12C159.914 187.573 157.781 188.8 153.514 188.8C149.248 188.8 147.114 187.573 147.114 185.12V113.28C147.114 104.96 140.341 100.8 126.794 100.8C113.354 100.8 106.634 104.96 106.634 113.28V185.12C106.634 187.573 104.501 188.8 100.234 188.8C95.9677 188.8 93.8344 187.573 93.8344 185.12Z"
        fill="black"
      />
    </svg>
  );
}

export default Logo;
